import { Component } from 'react'

class ErrorBoundary extends Component {
  state = { error: null }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, errorInfo) {
    
    console.error('Render error caught by ErrorBoundary:', error, errorInfo?.componentStack)
  }

  handleReload = () => {
    window.location.reload()
  }

  handleRetry = () => {
    this.setState({ error: null })
  }

  render() {
    const { error } = this.state
    if (!error) return this.props.children

    return (
      <div className="w-full h-full min-h-[240px] flex items-center justify-center p-6">
        <div className="max-w-md w-full bg-white border border-[#dfe4ed] rounded-lg p-6 flex flex-col items-center text-center">
          <span className="material-icons text-3xl text-[#d92d20]">error_outline</span>
          <span className="mt-3 text-sm font-medium text-[#272d37]">
            {this.props.title ?? 'Something went wrong'}
          </span>
          <span className="mt-1 text-sm font-normal text-[#616a79]">
            This view stopped responding to incoming data. Retry to re-render it, or reload the app.
          </span>
          {error.message && (
            <span className="mt-3 w-full text-xs font-normal text-[#616a79] bg-[#f9fafa] border border-[#dfe4ed] rounded-md px-3 py-2 text-left break-words">
              {error.message}
            </span>
          )}
          <div className="mt-4 flex items-center gap-2">
            <button
              className="h-8 px-3 border border-[#dfe4ed] rounded-md bg-white cursor-pointer text-sm text-[#272d37]"
              onClick={this.handleRetry}
            >
              Retry
            </button>
            <button
              className="h-8 px-3 border-none rounded-md bg-[#272d37] cursor-pointer text-sm text-white"
              onClick={this.handleReload}
            >
              Reload app
            </button>
          </div>
        </div>
      </div>
    )
  }
}

export default ErrorBoundary
